import { TireSetMountSceneProps, TireSetMountStepText } from "./types";

export const TIRE_SET_MOUNT_VEHICLE_STEP = 0;
export const TIRE_SET_MOUNT_OLD_SET_STEP = 1;
export const TIRE_SET_MOUNT_SUMMARY_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const TIRE_SET_MOUNT_INTRO_TEXTS: Record<number, TireSetMountStepText> = {
  [TIRE_SET_MOUNT_VEHICLE_STEP]: {
    title: "Na koje vozilo ide set?",
    description: "Odaberite vozilo i datum montaže. Set guma sa skladišta prelazi na vozilo.",
  },
  [TIRE_SET_MOUNT_OLD_SET_STEP]: {
    title: "Što sa starim setom?",
    description: "Vozilo već vozi na svojim gumama. Odaberite skladište na koje se spremaju.",
  },
  [TIRE_SET_MOUNT_SUMMARY_STEP]: {
    title: "Provjerite montažu",
    description: "Pregledajte zamjenu prije potvrde. Obje promjene lokacije ostaju zapisane u povijesti.",
  },
};

/** Primjeri dok korisnik ništa nije odabrao. */
export const TIRE_SET_MOUNT_INTRO_SAMPLE = {
  fromWarehouse: "Skladište Jankomir",
  vehicleName: "Škoda Octavia",
  vehicleRegistration: "ZG 1234 AB",
  vehicleImage: "/media/images/vehicles/vehicle-2.png",
  oldSetCode: "SET 0017",
  oldSetWarehouse: "Skladište Sesvete",
};

/** Oznaka kad je vozilo ili skladište odabrano, a naziv još nije razriješen. */
export const TIRE_SET_MOUNT_SELECTED_VEHICLE = "Odabrano vozilo";
export const TIRE_SET_MOUNT_SELECTED_WAREHOUSE = "Odabrano skladište";

/** Vozilo za prikaz: razriješeno vozilo, oznaka odabira ili primjer. */
export const getMountVehicle = ({
  formValues,
  targetVehicleName,
  targetVehicleRegistration,
  targetVehicleImage,
}: TireSetMountSceneProps) => {
  if (targetVehicleName) {
    return {
      name: targetVehicleName,
      registration: targetVehicleRegistration || "",
      image: targetVehicleImage || TIRE_SET_MOUNT_INTRO_SAMPLE.vehicleImage,
    };
  }
  return {
    name: formValues.targetVehicleId ? TIRE_SET_MOUNT_SELECTED_VEHICLE : TIRE_SET_MOUNT_INTRO_SAMPLE.vehicleName,
    registration: formValues.targetVehicleId ? "" : TIRE_SET_MOUNT_INTRO_SAMPLE.vehicleRegistration,
    image: TIRE_SET_MOUNT_INTRO_SAMPLE.vehicleImage,
  };
};

/** Skladište starog seta: razriješeno, oznaka odabira ili primjer. */
export const getMountOldSetWarehouse = ({ formValues, oldSetWarehouseName }: TireSetMountSceneProps) =>
  oldSetWarehouseName ||
  (formValues.oldSetWarehouseId ? TIRE_SET_MOUNT_SELECTED_WAREHOUSE : TIRE_SET_MOUNT_INTRO_SAMPLE.oldSetWarehouse);
